import { ColorX } from "IZOX/STATIC";

/**
 * @typedef {Object} policyStatus
 * @property {import("IZOX/__typedef/common").lang} label
 * @property {String} color
 * @property {String} bgColor
 */

class ClaimUtils {

  /**
   * @type {Object<string, policyStatus>}
   */
  static __status = {
    Submitted: {
      label: {
        EN: "Submitted",
        TC: "已提交"
      },
      color: ColorX.CSS("Renewed"),
      bgColor: ColorX.CSS("RenewedBg")
    },
    Declined: {
      label: {
        EN: "Declined",
        TC: "已拒絕"
      },
      color: ColorX.CSS("Pending"),
      bgColor: ColorX.CSS("PendingBg")
    },
    Approved: {
      label: {
        EN: "Approved",
        TC: "已核准"
      },
      color: ColorX.CSS("Active"),
      bgColor: ColorX.CSS("ActiveBg")
    },
    Completed: {
      label: {
        EN: "Completed",
        TC: "已完成"
      },
      color: ColorX.CSS("Canceled"),
      bgColor: ColorX.CSS("CanceledBg")
    }
  };

  /**
   * 
   * @param {status} status 
   * @returns {policyStatus}
   */
  static GetStatus(status){
    return this.__status[status] ?? null;
  }

}

export default ClaimUtils;